import Input from "./input"
export type { InputProps } from "./input"

// type CompoundedComponent = React.ForwardRefExoticComponent<InputProps> & {
//   Search: typeof Search;
// };

// const Input = InternalInput as CompoundedComponent

//TODO:
// Input.Search = Search

// export {
//   Input,
//   Search,
// }

export default Input
